module.exports = __webpack_public_path__ + "static/media/change-gear.01d29a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/change-gear.png
// module id = 757
// module chunks = 0